import React from "react";

const PrevIcon = (props) => {
	return (
		<svg
			width="44"
			height="44"
			viewBox="0 0 44 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<rect
				x="0.5"
				y="0.5"
				width="43"
				height="43"
				rx="21.5"
				stroke="#A0A3BD"
			/>
			<path
				d="M24.668 15.332L17.8971 20.9744C17.2575 21.5075 17.2575 22.4899 17.8971 23.023L24.668 28.6654"
				stroke="#A0A3BD"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export default PrevIcon;
